import { ModalHandler } from '@app-velocity/ui';

import { SoftwareLicensesModalContent } from './components/SoftwareLicensesModalContent';

export const SoftwareLicensesModal = () => {
  return (
    <ModalHandler
      id="software-license"
      channel="users"
    >
      <SoftwareLicensesModalContent />
    </ModalHandler>
  );
};
